export default __webpack_public_path__ + "static/media/video.68866ab8.mp4";